import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-columns-selection-popup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './columns-selection-popup.component.html',
  styleUrl: './columns-selection-popup.component.scss'
})
export class ColumnsSelectionPopupComponent implements OnInit {


  @Input() Content: any;

  Columns: any;
  IsAllSelected: boolean = false;
  istAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '2', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  istMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '2', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  grantsAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '4', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  grantsMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '4', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  eapAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '5', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  eapMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '5', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  userPreferenceColumnsLst: UserPreferenceColumnsList = { IstAllApplications: this.istAlluserPreferenceColumns, IstMyApplications: this.istMyuserPreferenceColumns, GrantsAllApplications: this.grantsAlluserPreferenceColumns, GrantsMyApplications: this.grantsMyuserPreferenceColumns,EapAllApplications: this.eapAlluserPreferenceColumns, EapMyApplications: this.eapMyuserPreferenceColumns };

  constructor(
    private ngActiveModal: NgbActiveModal,
    private commonService: CommonService
  ) {

  }

  ngOnInit(): void {

    this.getUserPreferncesColumns();

    this.Columns = this.Content.columns;

    if (this.Columns.every(x => x.IsSelected)) {
      this.IsAllSelected = true;
    }
  }

  checkUncheckcolumn(index: number) {

    if (this.Columns[index].IsSelected) {
      this.Columns[index].IsSelected = false
    }
    else {
      this.Columns[index].IsSelected = true;
    }

    if (this.Columns.some(x => !x.IsSelected)) {
      this.IsAllSelected = false;
    }
    else {
      this.IsAllSelected = true;
    }
  }

  selectAll() {
    if (!this.IsAllSelected) {
      this.Columns.forEach(x => x.IsSelected = true);
    }
    else {
      this.Columns.forEach(x => x.IsSelected = false);
    }

  }

  CancelPopup() {
    this.ngActiveModal.close();
  }

  ok() {
    this.Columns.forEach(x => {
      if (this.istAlluserPreferenceColumns.ModuleID == this.Content.moduleId && this.istAlluserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.istAlluserPreferenceColumns.THERAPEUTIC_AREA_ID = x.IsSelected;
        }
        else if (x.FieldCode == 'STUDY_TYPE') {
          this.istAlluserPreferenceColumns.STUDY_TYPE = x.IsSelected;
        }
        else if (x.FieldCode == 'PRODUCTIDS') {
          this.istAlluserPreferenceColumns.PRODUCTIDS = x.IsSelected;
        }
        else if (x.FieldCode == 'SUBMITTED_ON') {
          this.istAlluserPreferenceColumns.SUBMITTED_ON = x.IsSelected;
        }
        else if (x.FieldCode == 'LAST_UPDATED_ON') {
          this.istAlluserPreferenceColumns.LAST_UPDATED_ON = x.IsSelected;
        }
      }
      if (this.istMyuserPreferenceColumns.ModuleID == this.Content.moduleId && this.istMyuserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.istMyuserPreferenceColumns.THERAPEUTIC_AREA_ID = x.IsSelected;
        }
        else if (x.FieldCode == 'STUDY_TYPE') {
          this.istMyuserPreferenceColumns.STUDY_TYPE = x.IsSelected;

        }
        else if (x.FieldCode == 'PRODUCTIDS') {
          this.istMyuserPreferenceColumns.PRODUCTIDS = x.IsSelected;
        }
        else if (x.FieldCode == 'SUBMITTED_ON') {
          this.istMyuserPreferenceColumns.SUBMITTED_ON = x.IsSelected;
        }
        else if (x.FieldCode == 'LAST_UPDATED_ON') {
          this.istMyuserPreferenceColumns.LAST_UPDATED_ON = x.IsSelected;
        }
      }
      if (this.grantsAlluserPreferenceColumns.ModuleID == this.Content.moduleId && this.grantsAlluserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.grantsAlluserPreferenceColumns.THERAPEUTIC_AREA_ID = x.IsSelected;
        }
        else if (x.FieldCode == 'STUDY_TYPE') {
          this.grantsAlluserPreferenceColumns.STUDY_TYPE = x.IsSelected;
        }
        else if (x.FieldCode == 'PRODUCTIDS') {
          this.grantsAlluserPreferenceColumns.PRODUCTIDS = x.IsSelected;
        }
        else if (x.FieldCode == 'SUBMITTED_ON') {
          this.grantsAlluserPreferenceColumns.SUBMITTED_ON = x.IsSelected;
        }
        else if (x.FieldCode == 'LAST_UPDATED_ON') {
          this.grantsAlluserPreferenceColumns.LAST_UPDATED_ON = x.IsSelected;
        }
      }
      if (this.grantsMyuserPreferenceColumns.ModuleID == this.Content.moduleId && this.grantsMyuserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.grantsMyuserPreferenceColumns.THERAPEUTIC_AREA_ID = x.IsSelected;
        }
        else if (x.FieldCode == 'STUDY_TYPE') {
          this.grantsMyuserPreferenceColumns.STUDY_TYPE = x.IsSelected;
        }
        else if (x.FieldCode == 'PRODUCTIDS') {
          this.grantsMyuserPreferenceColumns.PRODUCTIDS = x.IsSelected;
        }
        else if (x.FieldCode == 'SUBMITTED_ON') {
          this.grantsMyuserPreferenceColumns.SUBMITTED_ON = x.IsSelected;
        }
        else if (x.FieldCode == 'LAST_UPDATED_ON') {
          this.grantsMyuserPreferenceColumns.LAST_UPDATED_ON = x.IsSelected;
        }
      }
       if (this.eapAlluserPreferenceColumns.ModuleID == this.Content.moduleId && this.eapAlluserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.eapAlluserPreferenceColumns.THERAPEUTIC_AREA_ID = x.IsSelected;
        }
        else if (x.FieldCode == 'STUDY_TYPE') {
          this.eapAlluserPreferenceColumns.STUDY_TYPE = x.IsSelected;
        }
        else if (x.FieldCode == 'PRODUCTIDS') {
          this.eapAlluserPreferenceColumns.PRODUCTIDS = x.IsSelected;
        }
        else if (x.FieldCode == 'SUBMITTED_ON') {
          this.eapAlluserPreferenceColumns.SUBMITTED_ON = x.IsSelected;
        }
        else if (x.FieldCode == 'LAST_UPDATED_ON') {
          this.eapAlluserPreferenceColumns.LAST_UPDATED_ON = x.IsSelected;
        }
      }
      if (this.eapMyuserPreferenceColumns.ModuleID == this.Content.moduleId && this.eapMyuserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.eapMyuserPreferenceColumns.THERAPEUTIC_AREA_ID = x.IsSelected;
        }
        else if (x.FieldCode == 'STUDY_TYPE') {
          this.eapMyuserPreferenceColumns.STUDY_TYPE = x.IsSelected;

        }
        else if (x.FieldCode == 'PRODUCTIDS') {
          this.eapMyuserPreferenceColumns.PRODUCTIDS = x.IsSelected;
        }
        else if (x.FieldCode == 'SUBMITTED_ON') {
          this.eapMyuserPreferenceColumns.SUBMITTED_ON = x.IsSelected;
        }
        else if (x.FieldCode == 'LAST_UPDATED_ON') {
          this.eapMyuserPreferenceColumns.LAST_UPDATED_ON = x.IsSelected;
        }
      }
    });

    this.userPreferenceColumnsLst.IstAllApplications = this.istAlluserPreferenceColumns;
    this.userPreferenceColumnsLst.IstMyApplications = this.istMyuserPreferenceColumns;
    this.userPreferenceColumnsLst.GrantsAllApplications = this.grantsAlluserPreferenceColumns;
    this.userPreferenceColumnsLst.GrantsMyApplications = this.grantsMyuserPreferenceColumns;
    this.userPreferenceColumnsLst.EapAllApplications = this.eapAlluserPreferenceColumns;
    this.userPreferenceColumnsLst.EapMyApplications = this.eapMyuserPreferenceColumns;

    let userPreferncesJson = JSON.stringify(this.userPreferenceColumnsLst);

    this.commonService.SaveUserPreferencesColumns(userPreferncesJson).subscribe({
      next: res => {
        this.CancelPopup();
      }
    })
  }

  getUserPreferncesColumns() {
    this.commonService.GetUserPreferencesColumns().subscribe({
      next: res => {
        if (res) {
          this.userPreferenceColumnsLst = res;
          if(this.userPreferenceColumnsLst.IstAllApplications){
            this.istAlluserPreferenceColumns = this.userPreferenceColumnsLst.IstAllApplications;
          }
          if(this.userPreferenceColumnsLst.IstMyApplications){
            this.istMyuserPreferenceColumns = this.userPreferenceColumnsLst.IstMyApplications;
          }
          if(this.userPreferenceColumnsLst.EapMyApplications){
            this.eapMyuserPreferenceColumns = this.userPreferenceColumnsLst.EapMyApplications;
          }
          if(this.userPreferenceColumnsLst.EapAllApplications){
            this.eapAlluserPreferenceColumns = this.userPreferenceColumnsLst.EapAllApplications;
          }
          if(this.userPreferenceColumnsLst.GrantsAllApplications) {
            this.grantsAlluserPreferenceColumns = this.userPreferenceColumnsLst.GrantsAllApplications;
          }
          if(this.userPreferenceColumnsLst.GrantsAllApplications) {
            this.grantsMyuserPreferenceColumns = this.userPreferenceColumnsLst.GrantsMyApplications;
          }
          this.Columns.forEach(x => {
            if (this.istAlluserPreferenceColumns.ModuleID == this.Content.moduleId && this.istAlluserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
              if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
                 x.IsSelected = this.istAlluserPreferenceColumns.THERAPEUTIC_AREA_ID;
              }
              else if (x.FieldCode == 'STUDY_TYPE') {
                 x.IsSelected = this.istAlluserPreferenceColumns.STUDY_TYPE;
              }
              else if (x.FieldCode == 'PRODUCTIDS') {
                x.IsSelected = this.istAlluserPreferenceColumns.PRODUCTIDS;
              }
              else if (x.FieldCode == 'SUBMITTED_ON') {
                x.IsSelected = this.istAlluserPreferenceColumns.SUBMITTED_ON;
              }
              else if (x.FieldCode == 'LAST_UPDATED_ON') {
                x.IsSelected = this.istAlluserPreferenceColumns.LAST_UPDATED_ON;
              }
            }
            if (this.istMyuserPreferenceColumns.ModuleID == this.Content.moduleId && this.istMyuserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
              if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
                 x.IsSelected = this.istMyuserPreferenceColumns.THERAPEUTIC_AREA_ID;
              }
              else if (x.FieldCode == 'STUDY_TYPE') {
                x.IsSelected = this.istMyuserPreferenceColumns.STUDY_TYPE;
              }
              else if (x.FieldCode == 'PRODUCTIDS') {
                x.IsSelected = this.istMyuserPreferenceColumns.PRODUCTIDS;
              }
              else if (x.FieldCode == 'SUBMITTED_ON') {
                x.IsSelected = this.istMyuserPreferenceColumns.SUBMITTED_ON ;
              }
              else if (x.FieldCode == 'LAST_UPDATED_ON') {
                x.IsSelected = this.istMyuserPreferenceColumns.LAST_UPDATED_ON;
              }
            }
            if (this.grantsAlluserPreferenceColumns.ModuleID == this.Content.moduleId && this.grantsAlluserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
              if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
                 x.IsSelected = this.grantsAlluserPreferenceColumns.THERAPEUTIC_AREA_ID;
              }
              else if (x.FieldCode == 'STUDY_TYPE') {
                 x.IsSelected = this.grantsAlluserPreferenceColumns.STUDY_TYPE;
              } 
              else if (x.FieldCode == 'PRODUCTIDS') {
                x.IsSelected = this.grantsAlluserPreferenceColumns.PRODUCTIDS;
              }
              else if (x.FieldCode == 'SUBMITTED_ON') {
                x.IsSelected = this.grantsAlluserPreferenceColumns.SUBMITTED_ON ;
              }
              else if (x.FieldCode == 'LAST_UPDATED_ON') {
                x.IsSelected = this.grantsAlluserPreferenceColumns.LAST_UPDATED_ON;
              }
            }
            if (this.grantsMyuserPreferenceColumns.ModuleID == this.Content.moduleId && this.grantsMyuserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
              if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
                x.IsSelected = this.grantsMyuserPreferenceColumns.THERAPEUTIC_AREA_ID;
              }
              else if (x.FieldCode == 'STUDY_TYPE') {
                x.IsSelected = this.grantsMyuserPreferenceColumns.STUDY_TYPE;
              }
              else if (x.FieldCode == 'PRODUCTIDS') {
                x.IsSelected = this.grantsMyuserPreferenceColumns.PRODUCTIDS;
              }
              else if (x.FieldCode == 'SUBMITTED_ON') {
                x.IsSelected = this.grantsMyuserPreferenceColumns.SUBMITTED_ON;
              }
              else if (x.FieldCode == 'LAST_UPDATED_ON') {
                x.IsSelected = this.grantsMyuserPreferenceColumns.LAST_UPDATED_ON;
              }
            }
            if (this.eapAlluserPreferenceColumns.ModuleID == this.Content.moduleId && this.eapAlluserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
              
              if (x.FieldCode == 'SUBMITTED_ON') {
                x.IsSelected = this.eapAlluserPreferenceColumns.SUBMITTED_ON;
              }
              else if (x.FieldCode == 'LAST_UPDATED_ON') {
                x.IsSelected = this.eapAlluserPreferenceColumns.LAST_UPDATED_ON;
              }
            }
            if (this.eapMyuserPreferenceColumns.ModuleID == this.Content.moduleId && this.eapMyuserPreferenceColumns.IsAllApplications == this.Content.isAllApplications) {
             
               if (x.FieldCode == 'SUBMITTED_ON') {
                x.IsSelected = this.eapMyuserPreferenceColumns.SUBMITTED_ON ;
              }
              else if (x.FieldCode == 'LAST_UPDATED_ON') {
                x.IsSelected = this.eapMyuserPreferenceColumns.LAST_UPDATED_ON;
              }
            }
          });
          if (this.Columns.some(x => !x.IsSelected)) {
            this.IsAllSelected = false;
          }
          else {
            this.IsAllSelected = true;
          }
        }
      }
    })
  }
}

export interface UserPreferenceColumns {
  ModuleID: string;
  IsAllApplications: boolean;
  THERAPEUTIC_AREA_ID: boolean;
  STUDY_TYPE: boolean;
  PRODUCTIDS: boolean;
  SUBMITTED_ON: boolean;
  LAST_UPDATED_ON: boolean
}

export interface UserPreferenceColumnsList {
  IstAllApplications: UserPreferenceColumns;
  IstMyApplications: UserPreferenceColumns;
  GrantsAllApplications: UserPreferenceColumns;
  GrantsMyApplications: UserPreferenceColumns;
  EapAllApplications: UserPreferenceColumns;
  EapMyApplications: UserPreferenceColumns;
}
